<template>
  <div id="app" class="flex column">
    <div id="header" class="flex row spaced container">
      <div class="logo flex">
        <router-link to="/" class="flex" @click="menu = false">
          <img src="./assets/images/shared/Logo.svg" alt />
        </router-link>
      </div>
      <a href="#" class="nav-mobile--menu flex" @click="menu = !menu" v-if="isMobile">
        <img src="./assets/images/shared/menu.png" alt />
      </a>
      <transition name="fade">
        <div class="nav flex" v-if="this.menu" :class="[isMobile ? 'mobile column' : 'desktop']">
          <router-link to="/" class="link nav-link-ltr container">Home</router-link>
          <router-link to="/product" class="link nav-link-ltr container">Product</router-link>
          <div
            class="link nav-link-ltr container flex column center-content"
            @mouseover="dropdown = true"
            @mouseleave="dropdown = false"
          >
            Solutions
            <transition name="fade">
              <div class="solutions-dropdown" v-if="dropdown">
                <router-link to="/governments" class="dropdown-item flex">Governments</router-link>
                <router-link to="/merchant" class="dropdown-item flex">Merchants</router-link>
              </div>
            </transition>
          </div>
          <router-link to="/company" class="link nav-link-ltr container">Company</router-link>
          <a href="https://pesaflow.com/signin" class="link nav-link-ltr container">SignIn</a>
        </div>
      </transition>
    </div>
    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
    <div id="footer" class="flex row container">
      <div class="column">
        <div class="flex wrap div-breaks content-margin spaced">
          <div
            class="content-padded content-maintext dark-text content-left"
          >Focus less on accounting for money and spend more time planning for the future.</div>
          <div class="content-right">
            <div class="content-padded content-maintext">Get in touch</div>
            <div
              class="content-subtext content-padded"
            >Leave us with your email and we will get in touch with you.</div>
            <div class="flex spaced content-padded">
              <input type="text" name value placeholder="Your email" class="email-input text-white" />
              <a href="#" class="email-submit center-content">Send</a>
            </div>
          </div>
        </div>
        <div class="content-margin content-subtext wrap flex start-place">
          <div class="content-margin footer-desc">
            <img src="./assets/images/shared/Logo.svg" alt />
          </div>
          <div class="content-margin footer-desc">
            Contact our technical support team
            <br />
            <span class="linkesque">support@pesaflow.com</span>
          </div>
          <div class="content-margin footer-desc">
            Talk to us on
            <br />
            <span class="linkesque">+254 721 337 530</span>
          </div>
          <div class="content-margin footer-desc">
            Submit your enquiries to
            <br />
            <span class="linkesque">info@pesaflow.com</span>
          </div>
          <div class="content-margin footer-desc">
            Find us at
            <br />706 Tende Drive,
            <br />off Mzima Springs Road,
            <br />Lavington
            <br />Nairobi, Kenya
          </div>
        </div>
        <div class="content-margin">
          <div class="content-padded social flex spaced content-margin">
            <a
              href="https://www.facebook.com/PesaflowLtd/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./assets/images/shared/fb.svg" alt href />
            </a>
            <a href="https://twitter.com/pesaflow" target="_blank" rel="noopener noreferrer">
              <img src="./assets/images/shared/twitter.svg" alt href />
            </a>
            <a
              href="https://www.linkedin.com/company/pesaflow/about/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./assets/images/shared/linkedin.svg" alt href />
            </a>
          </div>
          <div class="flex spaced content-mintext">
            <div class>&#169; Pesaflow 2018</div>
            <div class>Privacy & Terms</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint max-len: 0 */
export default {
  data() {
    return {
      menu: false,
      dropdown: true,
    };
  },
  watch: {
    $route() {
      if (this.isMobile) {
        this.menu = false;
        return;
      }
      this.dropdown = false;
    },
  },
  computed: {
    isMobile() {
      if (window.innerWidth < 1024) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.menu = true;
      this.dropdown = false;
    }
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Work+Sans&display=swap");
@font-face {
  font-family: "BebasNeue";
  src: url("./assets/fonts/bebas_neue/BebasNeue-Regular.eot");
  src: url("./assets/fonts/bebas_neue/BebasNeue-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("./assets/fonts/bebas_neue/BebasNeue-Regular.woff") format("woff"),
    url("./assets/fonts/bebas_neue/BebasNeue-Regular.ttf") format("truetype");
  font-style: normal;
}
@font-face {
  font-family: "Averta";
  src: url("./assets/fonts/averta/AvertaDemoPECuttedDemo-Regular.otf")
    format("opentype");
  font-style: normal;
}

html,
body {
  height: 100%;
  margin: 0px;
}
a {
  text-decoration: none;
}
a:hover,
a:active,
a:focus {
  outline: 0;
}
.desktop-only {
  display: none;
}
.mobile-only {
  display: flex;
}
.link.router-link-exact-active,
.dropdown-item.router-link-exact-active {
  border-bottom: 2px solid #ae51c8;
}
.flex {
  display: flex;
}
.align-end {
  justify-content: flex-end;
}
.row {
  flex-direction: row;
  padding: 30px 30px;
}
.top-spaced {
  margin-top: 100px;
}
.content-slim {
  z-index: 9;
  width: 60%;
}
.container {
  position: relative;
}
.column {
  flex-direction: column;
}
.wrap {
  flex-direction: column;
}
.uppercase {
  text-transform: uppercase;
}
.pointer {
  cursor: pointer;
}
.content-padded {
  padding-bottom: 20px;
}
.content-margin {
  margin: 20px 0px;
}
.center-content {
  justify-content: center;
  align-items: center;
}
#app {
  font-family: "Averta", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  text-align: left;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
}
#header {
  z-index: 999;
  align-items: center;
  .logo {
    flex: 4;
    img {
      width: 175px;
    }
  }
  .nav {
    flex: 5;
    justify-content: space-between;
    .solutions-dropdown {
      position: relative;
      top: 0;
      left: 0;
      border: none;
      padding: 0;
      margin: 0;
      .dropdown-item {
        font-size: 0.8em;
        font-weight: normal;
        padding: 5px 0px;
        margin: 0;
        justify-content: center;
      }
    }
  }
}
#footer {
  background-color: #02134b;
  color: #fff;
  .dark-text {
    color: #b4bcd8;
  }
  .linkesque {
    text-decoration: underline;
  }
}
.page-title,
.page-title--norm {
  font-size: 31px;
  line-height: 40px;
}
.content-maintext {
  font-size: 20px;
  line-height: 30px;
}
.content-title {
  font-size: 17px;
  line-height: 21px;
}
.content-subtext {
  font-size: 14px;
  font-family: "Work Sans";
  line-height: 20px;
}
.content-mintext {
  font-size: 12px;
  line-height: 23px;
}
.linkesque {
  color: #91ccff;
}
.spaced {
  justify-content: space-between;
}
.nav-mobile--menu > img {
  width: 36px;
}
.nav.mobile {
  border-top: 2px solid #4d00a7;
  top: 65px;
  z-index: 9;
  background-color: #fff;
  width: 100%;
  position: absolute;
  right: 0;
  left: 0;
  justify-content: center;
  align-items: center;
}
.link {
  font-size: 1.3em;
  font-weight: bold;
  color: #333;
  padding-bottom: 10px;
  left: 0;
  margin: 10px 20px;
}
.div-breaks {
  background-color: #081c5d;
  padding: 15px;
  border-left: 2px solid #4d00a7;
}
.email-input {
  background-color: transparent;
  border: none;
  padding: 10px 0px;
  border-bottom: 1px solid #91ccff;
  &:focus {
    outline: none;
  }
}
.email-submit {
  background-color: #91ccff;
  color: #fff;
  font-size: 12px;
  height: 25px;
  width: 75px;
  display: flex;
  line-height: 25px;
  align-self: flex-end;
}
.social {
  width: 45%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
.top-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 130vh;
  width: 100%;
  z-index: -1;
  img {
    width: 100%;
    min-width: 100%;
    height: 130vh;
    object-fit: cover;
  }
}
.bolded {
  font-weight: bold;
}
.white {
  background-color: #fff;
}
.blue {
  background-color: #0187fb;
}
.overblue {
  background-color: #004480;
}
.med-blue {
  background-color: #6bbaff;
}
.dark-blue {
  background-color: #02134b;
}
.light-blue {
  background-color: rgba(145, 204, 255, 0.1);
}
.text-white {
  color: #fff;
}
.text-blue {
  color: #02134b;
}
.text-yellow {
  color: #f6921e;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.6;
}
.content-top {
  z-index: 9;
  min-height: 66vh;
  display: flex;
  flex-direction: column;
}
.content-subtitle {
  line-height: 25px;
  font-weight: bold;
}
.back-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  img {
    display: inline-block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}
.talk-btn {
  font-size: 1.3em;
  line-height: 2;
  padding: 0px 20px;
  height: 50%;
  border: none;
}
.equal-width {
  flex: 1;
}
.third-width {
  flex: 1 0 25%;
}
.footer-desc {
  img {
    width: 175px;
  }
}
.tabs__link {
  display: none !important;
}
.active_tab {
  display: flex !important;
}
@media only screen and (min-width: 1024px) {
  .row {
    padding: 40px 150px;
  }
  .desktop-only {
    display: flex;
  }
  .mobile-only {
    display: none;
  }
  .wrap {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .content-slim--desktop {
    z-index: 9;
    width: 60%;
  }
  .content-padded {
    padding: 30px 20px;
  }
  .content-maintext {
    font-size: 30px;
    line-height: 40px;
    max-width: 66%;
  }
  .content-mintext {
    font-size: 14px;
    line-height: 18px;
  }
  .content-subtext {
    font-family: "Work Sans";
    font-size: 14px;
    line-height: 24px;
  }
  .top-spaced {
    margin-top: 100px;
  }
  .desktop {
    .router-link-exact-active {
      font-weight: 900;
    }
    .link {
      border-bottom: none;
      font-weight: normal;
      color: #fff;
      &:before {
        transition: 300ms;
        width: 0%;
        height: 1px;
        bottom: 0;
        content: "";
        position: absolute;
        background-color: #ae51c8;
      }
      &:hover::before {
        width: 100%;
      }
    }
  }
  #header {
    .nav {
      .solutions-dropdown {
        position: absolute;
        top: 20px;
        background-color: #fff;
        padding-top: 10px;
        color: #333;
        margin-top: 10px;
        padding-right: 10px;
        border-top: 2px solid orange;
        min-width: 160px;
        .dropdown-item {
          font-size: 1em;
          margin-left: 20px;
          justify-content: flex-start;
          margin-bottom: 10px;
          padding-bottom: 5px;
          padding-right: 10px;
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
  #footer {
    .content-left {
      flex-basis: 40%;
    }
    .content-right {
      flex-basis: 40%;
    }
    .div-breaks {
      padding: 40px;
    }
    .footer-desc {
      flex: 1 0 33%;
      max-width: 33%;
      line-height: 2.6;
    }
  }
  .third-width {
    padding-right: 40px;
    padding-left: 0px;
    max-width: 25%;
  }
  .page-title--norm {
    font-size: 40px;
    line-height: 51px;
    padding-top: 10%;
  }
  .content-top {
    .content-mintext {
      font-size: 17px;
      line-height: 24px;
    }
  }
  .vertical-center {
    align-items: center;
  }
  .top-rule:before {
    content: "";
    width: 40%;
    height: 1px;
    background: #91ccff;
    position: absolute;
    top: -5px;
  }
  .email-input {
    font-size: 1.3em;
  }
  .left-vertical-tabs {
    padding: 20px 0px;
    flex: 2;
  }
  .tab-content {
    flex: 4;
  }
  .tabs__link {
    display: flex !important;
  }
  .active_tab {
    display: flex !important;
  }
}
</style>
